import { iSharedCartSearch } from "../../api/sharedCart/sharedCart";
import { iSource } from "../../context/sourceContext/SourceContext";

export type PickPart = "hotel" | "flight" | "activity";
export type PickSource = Exclude<iSource, "mcp">;
export type PickSearchPart = keyof iSharedCartSearch;

type PickSources = Partial<Record<PickPart, PickSource>>;

const PICK_SOURCE_KEY = "_zenvoya_pick_source";
const PICK_SEARCH_KEY = "_zenvoya_pick_search";

const readStored = <T extends object>(key: string): T => {
  try {
    const stored = JSON.parse(sessionStorage.getItem(key) ?? "{}");
    return stored && typeof stored === "object" ? stored : ({} as T);
  } catch {
    return {} as T;
  }
};

const writeStored = (key: string, value: object): void => {
  try {
    if (Object.keys(value).length > 0) sessionStorage.setItem(key, JSON.stringify(value));
    else sessionStorage.removeItem(key);
  } catch {}
};

export const getPickSource = (part: PickPart): PickSource => readStored<PickSources>(PICK_SOURCE_KEY)[part] ?? "booking";

export const setPickSource = (part: PickPart, source: PickSource): void =>
  writeStored(PICK_SOURCE_KEY, { ...readStored<PickSources>(PICK_SOURCE_KEY), [part]: source });

export const getPickSearch = (): iSharedCartSearch => readStored<iSharedCartSearch>(PICK_SEARCH_KEY);

export const setPickSearch = <K extends PickSearchPart>(part: K, search: iSharedCartSearch[K]): void => {
  const searches = getPickSearch();
  if (search) searches[part] = search;
  else delete searches[part];
  writeStored(PICK_SEARCH_KEY, searches);
};

export const clearPickSource = (...parts: PickPart[]): void => {
  const sources = readStored<PickSources>(PICK_SOURCE_KEY);
  const searches = getPickSearch();
  parts.forEach((part) => {
    delete sources[part];
    if (part !== "activity") delete searches[part];
  });
  writeStored(PICK_SOURCE_KEY, sources);
  writeStored(PICK_SEARCH_KEY, searches);
};
